import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
//import { AdataService } from '../../shared/adata.service';
import { Search } from '../../shared/adata.model';
import { UserService } from '../../shared/user.service';
import swal from 'sweetalert2';
// import { Search } from '../../../shared/adata.model';

@Component({
  selector: 'app-agent-creation-grid',
  templateUrl: './agent-creation-grid.component.html',
  styleUrls: ['./agent-creation-grid.component.css']
})
export class AgentCreationGridComponent implements OnInit {
// title="Pigmy Agents List"
//   constructor() { }

//   ngOnInit() {
//   }

// }

title = "Pigmy Agents List";

  itemsPerPage: number=5;
  currentPage: number=1;
  data : any = {};  
  totalItems : number;
  s: Search;
  isSearch:boolean = false;
  AGENT_ID : number;
  PigmyDetailsList: any = {};
  logbranch:any;

  constructor(private Service: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }
   ngOnInit() { 
    this.GetPigmyDetails(this.itemsPerPage, 1)
  }

 

  //List of Case Proceedings
  GetPigmyDetails(itemsPerPage:any,pageNo:any){
    debugger;
  this.logbranch=localStorage.getItem('BRANCH_ID');
  // this.isSearch = false;
    // document.getElementById('loader-spinner').style.display = "block";
    this.data = this.Service.GetPigmyDetails(itemsPerPage,pageNo,this.logbranch);
    this.data.subscribe(
      (response: any) => {
        this.PigmyDetailsList = response.PigmyModel;
          this.totalItems = response.TotalItemsCount;
          this.itemsPerPage = itemsPerPage;
          this.currentPage = pageNo;
        // console.log('pigmy Deatils');
        console.log(this.PigmyDetailsList);    
        // document.getElementById('loader-spinner').style.display = "none";
      },
      // (error) => {
      //   // document.getElementById('loader-spinner').style.display = "none";
      //   if (error.status == 401) {
      //     this.errorHandler.handleError(error);
      //   }
      //   else if (error.status == 400) {
      //     // swal('Warning!', error.error.Message, 'warning');
      //     alert('Warning! error.error.Message' )
      //   }
      // });
    )
  }
  
  delete(AGENT_ID){
  


    
    debugger;
  

    
   swal({
      title: 'Are you sure?', text: "You want to delete!", type: 'warning',
       showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
       
        if (result.value) 
        {
        this.data = this.Service.DeletePigmy(AGENT_ID);
        this.data.subscribe(
         (response: any) =>
          {
          this.GetPigmyDetails(this.itemsPerPage, 1)
            //alert('Inside');;          
         },
          (error) => {
          // document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            // swal('Warning!', error.error.Message, 'warning');
          }
        }    
      ); 
    } 
  })
}


    pageChanged(pageNumber: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNumber);
      else
        this.GetPigmyDetails(this.itemsPerPage, pageNumber);
    }
  
    itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
      if (this.isSearch)
        this.onSearch(this.s, this.itemsPerPage, pageNo);
      else
        this.GetPigmyDetails(this.itemsPerPage, pageNo);
    }


  //Search item


  onSearch(s, itemsPerPage: number, pageNo: number) { 

debugger;
    this.isSearch = true;
    let searchText = this.s.SearchText;
    let searchCriteria = this.s.SearchCriteria;
    if (searchText == "" || searchText == null) 
       swal("Warning!", "Please enter the search text.", "warning");
     // alert("Warning!" );
     else if(searchCriteria == "" || searchCriteria == null)
     swal("Warning!", "Please enter the Search Criteria .", "warning");
    else {
      // document.getElementById('loader-spinner').style.display = "block";
      this.Service.SearchPigmy(searchCriteria, searchText, itemsPerPage, pageNo)
        .subscribe(
          (data: any) => {
            if(data.PigmyModel.length!=0){              
            this.PigmyDetailsList = data.PigmyModel;
            this.totalItems = data.TotalItemsCount;
            this.currentPage = pageNo;
            // document.getElementById('loader-spinner').style.display = "none";
          }
          else
          {
          // document.getElementById('loader-spinner').style.display = "none";         
          }
          }, (error) => {
            // document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              // swal('Warning!', error.error.Message, 'warning');
            }
          });
    }
  }



}




// WEBPACK FOOTER //
// ./src/app/unicore-masters/agent-creation-grid/agent-creation-grid.component.ts